








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../mti/metadata_pb.js');
var google_protobuf_timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.mti.FixtureHealth',null,global);
goog.exportSymbol('proto.mti.HealthState',null,global);
goog.exportSymbol('proto.mti.HealthStatus',null,global);
goog.exportSymbol('proto.mti.PositionHealth',null,global);
goog.exportSymbol('proto.mti.StoreHealth',null,global);











proto.mti.StoreHealth=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.StoreHealth,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.StoreHealth.displayName='proto.mti.StoreHealth';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.StoreHealth.prototype.toObject=function(opt_includeInstance){
return proto.mti.StoreHealth.toObject(opt_includeInstance,this);
};











proto.mti.StoreHealth.toObject=function(includeInstance,msg){
var f,obj={
storeId:jspb.Message.getFieldWithDefault(msg,1,0)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.StoreHealth.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.StoreHealth();
return proto.mti.StoreHealth.deserializeBinaryFromReader(msg,reader);
};









proto.mti.StoreHealth.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=reader.readUint64();
msg.setStoreId(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.StoreHealth.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.StoreHealth.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.StoreHealth.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
1,
f);

}
};






proto.mti.StoreHealth.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,1,0);
};



proto.mti.StoreHealth.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,1,value);
};













proto.mti.FixtureHealth=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.FixtureHealth,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.FixtureHealth.displayName='proto.mti.FixtureHealth';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.FixtureHealth.prototype.toObject=function(opt_includeInstance){
return proto.mti.FixtureHealth.toObject(opt_includeInstance,this);
};











proto.mti.FixtureHealth.toObject=function(includeInstance,msg){
var f,obj={
storeId:jspb.Message.getFieldWithDefault(msg,1,0),
fixtureId:jspb.Message.getFieldWithDefault(msg,2,0)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.FixtureHealth.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.FixtureHealth();
return proto.mti.FixtureHealth.deserializeBinaryFromReader(msg,reader);
};









proto.mti.FixtureHealth.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 2:
var value=reader.readUint64();
msg.setFixtureId(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.FixtureHealth.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.FixtureHealth.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.FixtureHealth.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
1,
f);

}
f=message.getFixtureId();
if(f!==0){
writer.writeUint64(
2,
f);

}
};






proto.mti.FixtureHealth.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,1,0);
};



proto.mti.FixtureHealth.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,1,value);
};






proto.mti.FixtureHealth.prototype.getFixtureId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.FixtureHealth.prototype.setFixtureId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};













proto.mti.PositionHealth=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.PositionHealth,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.PositionHealth.displayName='proto.mti.PositionHealth';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.PositionHealth.prototype.toObject=function(opt_includeInstance){
return proto.mti.PositionHealth.toObject(opt_includeInstance,this);
};











proto.mti.PositionHealth.toObject=function(includeInstance,msg){
var f,obj={
storeId:jspb.Message.getFieldWithDefault(msg,1,0),
fixtureId:jspb.Message.getFieldWithDefault(msg,2,0),
positionId:jspb.Message.getFieldWithDefault(msg,3,0)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.PositionHealth.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.PositionHealth();
return proto.mti.PositionHealth.deserializeBinaryFromReader(msg,reader);
};









proto.mti.PositionHealth.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 2:
var value=reader.readUint64();
msg.setFixtureId(value);
break;
case 3:
var value=reader.readUint64();
msg.setPositionId(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.PositionHealth.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.PositionHealth.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.PositionHealth.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
1,
f);

}
f=message.getFixtureId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getPositionId();
if(f!==0){
writer.writeUint64(
3,
f);

}
};






proto.mti.PositionHealth.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,1,0);
};



proto.mti.PositionHealth.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,1,value);
};






proto.mti.PositionHealth.prototype.getFixtureId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.PositionHealth.prototype.setFixtureId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.PositionHealth.prototype.getPositionId=function(){
return jspb.Message.getFieldWithDefault(this,3,0);
};



proto.mti.PositionHealth.prototype.setPositionId=function(value){
jspb.Message.setProto3IntField(this,3,value);
};













proto.mti.HealthState=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,proto.mti.HealthState.oneofGroups_);
};
goog.inherits(proto.mti.HealthState,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.HealthState.displayName='proto.mti.HealthState';
}








proto.mti.HealthState.oneofGroups_=[[4,5,6]];




proto.mti.HealthState.RuleOneofCase={
RULE_ONEOF_NOT_SET:0,
STORE_HEALTH:4,
FIXTURE_HEALTH:5,
POSITION_HEALTH:6};





proto.mti.HealthState.prototype.getRuleOneofCase=function(){
return jspb.Message.computeOneofCase(this,proto.mti.HealthState.oneofGroups_[0]);
};



if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.HealthState.prototype.toObject=function(opt_includeInstance){
return proto.mti.HealthState.toObject(opt_includeInstance,this);
};











proto.mti.HealthState.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
statusUuid:msg.getStatusUuid_asB64(),
statusUpdatedAt:(f=msg.getStatusUpdatedAt())&&google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance,f),
storeHealth:(f=msg.getStoreHealth())&&proto.mti.StoreHealth.toObject(includeInstance,f),
fixtureHealth:(f=msg.getFixtureHealth())&&proto.mti.FixtureHealth.toObject(includeInstance,f),
positionHealth:(f=msg.getPositionHealth())&&proto.mti.PositionHealth.toObject(includeInstance,f),
status:jspb.Message.getFieldWithDefault(msg,7,0),
reason:jspb.Message.getFieldWithDefault(msg,8,""),
humanReadableReason:jspb.Message.getFieldWithDefault(msg,9,""),
humanReadableReasonAction:jspb.Message.getFieldWithDefault(msg,10,"")};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.HealthState.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.HealthState();
return proto.mti.HealthState.deserializeBinaryFromReader(msg,reader);
};









proto.mti.HealthState.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readBytes();
msg.setStatusUuid(value);
break;
case 3:
var value=new google_protobuf_timestamp_pb.Timestamp();
reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
msg.setStatusUpdatedAt(value);
break;
case 4:
var value=new proto.mti.StoreHealth();
reader.readMessage(value,proto.mti.StoreHealth.deserializeBinaryFromReader);
msg.setStoreHealth(value);
break;
case 5:
var value=new proto.mti.FixtureHealth();
reader.readMessage(value,proto.mti.FixtureHealth.deserializeBinaryFromReader);
msg.setFixtureHealth(value);
break;
case 6:
var value=new proto.mti.PositionHealth();
reader.readMessage(value,proto.mti.PositionHealth.deserializeBinaryFromReader);
msg.setPositionHealth(value);
break;
case 7:
var value=reader.readEnum();
msg.setStatus(value);
break;
case 8:
var value=reader.readString();
msg.setReason(value);
break;
case 9:
var value=reader.readString();
msg.setHumanReadableReason(value);
break;
case 10:
var value=reader.readString();
msg.setHumanReadableReasonAction(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.HealthState.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.HealthState.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.HealthState.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStatusUuid_asU8();
if(f.length>0){
writer.writeBytes(
2,
f);

}
f=message.getStatusUpdatedAt();
if(f!=null){
writer.writeMessage(
3,
f,
google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);

}
f=message.getStoreHealth();
if(f!=null){
writer.writeMessage(
4,
f,
proto.mti.StoreHealth.serializeBinaryToWriter);

}
f=message.getFixtureHealth();
if(f!=null){
writer.writeMessage(
5,
f,
proto.mti.FixtureHealth.serializeBinaryToWriter);

}
f=message.getPositionHealth();
if(f!=null){
writer.writeMessage(
6,
f,
proto.mti.PositionHealth.serializeBinaryToWriter);

}
f=message.getStatus();
if(f!==0.0){
writer.writeEnum(
7,
f);

}
f=message.getReason();
if(f.length>0){
writer.writeString(
8,
f);

}
f=message.getHumanReadableReason();
if(f.length>0){
writer.writeString(
9,
f);

}
f=message.getHumanReadableReasonAction();
if(f.length>0){
writer.writeString(
10,
f);

}
};






proto.mti.HealthState.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.HealthState.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.HealthState.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.HealthState.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.HealthState.prototype.getStatusUuid=function(){
return jspb.Message.getFieldWithDefault(this,2,"");
};







proto.mti.HealthState.prototype.getStatusUuid_asB64=function(){
return jspb.Message.bytesAsB64(
this.getStatusUuid());
};









proto.mti.HealthState.prototype.getStatusUuid_asU8=function(){
return jspb.Message.bytesAsU8(
this.getStatusUuid());
};



proto.mti.HealthState.prototype.setStatusUuid=function(value){
jspb.Message.setProto3BytesField(this,2,value);
};






proto.mti.HealthState.prototype.getStatusUpdatedAt=function(){
return(
jspb.Message.getWrapperField(this,google_protobuf_timestamp_pb.Timestamp,3));
};



proto.mti.HealthState.prototype.setStatusUpdatedAt=function(value){
jspb.Message.setWrapperField(this,3,value);
};


proto.mti.HealthState.prototype.clearStatusUpdatedAt=function(){
this.setStatusUpdatedAt(undefined);
};






proto.mti.HealthState.prototype.hasStatusUpdatedAt=function(){
return jspb.Message.getField(this,3)!=null;
};






proto.mti.HealthState.prototype.getStoreHealth=function(){
return(
jspb.Message.getWrapperField(this,proto.mti.StoreHealth,4));
};



proto.mti.HealthState.prototype.setStoreHealth=function(value){
jspb.Message.setOneofWrapperField(this,4,proto.mti.HealthState.oneofGroups_[0],value);
};


proto.mti.HealthState.prototype.clearStoreHealth=function(){
this.setStoreHealth(undefined);
};






proto.mti.HealthState.prototype.hasStoreHealth=function(){
return jspb.Message.getField(this,4)!=null;
};






proto.mti.HealthState.prototype.getFixtureHealth=function(){
return(
jspb.Message.getWrapperField(this,proto.mti.FixtureHealth,5));
};



proto.mti.HealthState.prototype.setFixtureHealth=function(value){
jspb.Message.setOneofWrapperField(this,5,proto.mti.HealthState.oneofGroups_[0],value);
};


proto.mti.HealthState.prototype.clearFixtureHealth=function(){
this.setFixtureHealth(undefined);
};






proto.mti.HealthState.prototype.hasFixtureHealth=function(){
return jspb.Message.getField(this,5)!=null;
};






proto.mti.HealthState.prototype.getPositionHealth=function(){
return(
jspb.Message.getWrapperField(this,proto.mti.PositionHealth,6));
};



proto.mti.HealthState.prototype.setPositionHealth=function(value){
jspb.Message.setOneofWrapperField(this,6,proto.mti.HealthState.oneofGroups_[0],value);
};


proto.mti.HealthState.prototype.clearPositionHealth=function(){
this.setPositionHealth(undefined);
};






proto.mti.HealthState.prototype.hasPositionHealth=function(){
return jspb.Message.getField(this,6)!=null;
};






proto.mti.HealthState.prototype.getStatus=function(){
return jspb.Message.getFieldWithDefault(this,7,0);
};



proto.mti.HealthState.prototype.setStatus=function(value){
jspb.Message.setProto3EnumField(this,7,value);
};






proto.mti.HealthState.prototype.getReason=function(){
return jspb.Message.getFieldWithDefault(this,8,"");
};



proto.mti.HealthState.prototype.setReason=function(value){
jspb.Message.setProto3StringField(this,8,value);
};






proto.mti.HealthState.prototype.getHumanReadableReason=function(){
return jspb.Message.getFieldWithDefault(this,9,"");
};



proto.mti.HealthState.prototype.setHumanReadableReason=function(value){
jspb.Message.setProto3StringField(this,9,value);
};






proto.mti.HealthState.prototype.getHumanReadableReasonAction=function(){
return jspb.Message.getFieldWithDefault(this,10,"");
};



proto.mti.HealthState.prototype.setHumanReadableReasonAction=function(value){
jspb.Message.setProto3StringField(this,10,value);
};





proto.mti.HealthStatus={
HEALTHY:0,
UNHEALTHY:1,
HEALTH_WARNING:2};


goog.object.extend(exports,proto.mti);